import { render, staticRenderFns } from "./DriverContractDocumentsWidget.vue?vue&type=template&id=fbbe9c3c&scoped=true&"
import script from "./DriverContractDocumentsWidget.vue?vue&type=script&lang=js&"
export * from "./DriverContractDocumentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./DriverContractDocumentsWidget.vue?vue&type=style&index=0&id=fbbe9c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbe9c3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbbe9c3c')) {
      api.createRecord('fbbe9c3c', component.options)
    } else {
      api.reload('fbbe9c3c', component.options)
    }
    module.hot.accept("./DriverContractDocumentsWidget.vue?vue&type=template&id=fbbe9c3c&scoped=true&", function () {
      api.rerender('fbbe9c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/DriverContractDocumentsWidget.vue"
export default component.exports